import React from 'react';
import { AmplifyCore } from '@codametrix/ui-common';
import { Provider, connect } from 'react-redux';
import { InvoiceEditor } from './invoice-editor';

const {
  removeAdditionPerformer,
  removeAdditionReferringPerformer,
  chooseAdditionPerformer,
  chooseAdditionReferringPerformer,
  changePerformDate,
  createInvoice,
  addProvider,
  cancelChargeEdit,
  chooseProvider,
  providerSearch,
  removeProvider,
  saveInvoice,
  departmentChange,
  feeScheduleChange
} = AmplifyCore.actions;

export const mapStateToInvoiceEditorProps = (state: any): any => {
  return {
    ...state.invoiceMetadata,
    providerRoleTypeConfig: state?.codeBench?.providerRoleTypeConfig ?? [],
    useProviderDirectoryLocations:
      state?.capabilities?.capabilities?.useProviderDirectoryLocations
  };
};

export const mapDispatchToInvoiceEditorProps = (
  dispatch: any
): Accelerate.InvoiceMetadataMethods => {
  return {
    onProviderSearch: (query: CMxCommonApp.LookupQuery) => {
      dispatch(providerSearch(query));
    },
    onProviderRemove: () => {
      dispatch(removeProvider());
    },
    onProviderAdd: (provider: any) => {
      dispatch(chooseProvider(provider));
    },
    onInvoiceSave: (savableInvoice: Accelerate.SavableInvoice) => {
      dispatch(saveInvoice(savableInvoice));
    },
    onPerformerAdditionSearch: (query: CMxCommonApp.LookupQuery) => {
      dispatch(providerSearch(query));
    },
    onPerformerAdditionRemove: () => {
      dispatch(removeAdditionPerformer());
    },
    onReferringPerformerAdditionRemove: () => {
      dispatch(removeAdditionReferringPerformer());
    },
    onPerformerAdditionAdd: (provider: any) => {
      dispatch(chooseAdditionPerformer(provider));
    },
    onReferrerPerformerAdditionAdd: (provider: any) => {
      dispatch(chooseAdditionReferringPerformer(provider));
    },
    onPerformDateChange: (newDate: string) => {
      dispatch(changePerformDate(newDate));
    },
    onInvoiceCreate: async (createbleInvoice: Accelerate.CreatebleInvoice) => {
      try {
        await dispatch(createInvoice(createbleInvoice));
      } catch (error) {
        console.error('Error from createInvoice action:', error);
      }
    },
    onInvoiceCancel: e => {
      e?.preventDefault();
      dispatch(cancelChargeEdit());
    },
    onDepartmentChange: (department: string) => {
      dispatch(departmentChange(department));
    },
    onRemoveDepartment: () => {
      dispatch(departmentChange(null));
    },
    onFeeScheduleChange: (feeSchedule: string) => {
      dispatch(feeScheduleChange(feeSchedule));
    }
  };
};
